<template>
  <div>
    <v-col cols="11" sm="12" md="12">
      <v-row style="padding: 2%" justify="center" align="center">
        <div class="card1">Add Sub Categories</div>
        <div class="card">
          <v-col cols="12" sm="12" md="5" style="padding: 2%">
            <div class="header">Name</div>
            <v-text-field v-model="name" solo outlined dense :rules="nameRules"></v-text-field>
            <div class="header">Upload Image</div>
            <input type="file" accept="image/*" @change="handleFileUpload">
          </v-col>
        </div>
      </v-row>
      <v-row style="padding: 1%; margin-top: -2%">
        <v-col cols="12" sm="3" md="3">
          <v-row>
            <v-btn @click="createCategory(selectedId)" class="white--text save-btn">{{ buttonText }} subcategory</v-btn>
            <v-btn @click="goBack()" class="back-btn">Cancel</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-row justify="center">
      <v-overlay :value="loading" style="z-index: 999">
        <v-progress-circular :size="100" color="#008080" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
  </div>
</template>

<script>
import { ref } from "vue";
import { addDoc, collection, getFirestore } from "firebase/firestore";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

const db = getFirestore();
const storage = getStorage();

export default {
  name: "App",
  data() {
    return {
      loading: false,
      name: "",
      image: null,
      selectedId: null ,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => /^[a-zA-Z ]*$/.test(v) || "Name can only contain letters",
      ],
      buttonText: "Create",
    };
  },
  methods: {
    async createCategory(selectedId) {
      if (!this.validateForm()) return;

      console.error("selectedId:", selectedId);

      try {
        const categoryData = {
          name: this.name,
          imageUrl: null, // Will be updated after uploading the image
        };

        if (this.image) {
          // Perform image upload if an image is selected
          const imageName = new Date().getTime() + "_" + this.image.name;
          const imageStorageRef = storageRef(storage, "images/" + imageName); // Creating a reference to the storage path
          await uploadBytes(imageStorageRef, this.image); // Uploading the image
          const imagePath = await getDownloadURL(imageStorageRef); // Getting the download URL
          categoryData.imagePath = imagePath;
        }

        await addDoc(collection(db, 'Category', selectedId, 'subcategories'), categoryData);

        // Clear input fields after successful save
        this.name = "";
        this.imagePath = null;

        // Navigate to templateName component and pass tempName as parameter
        this.$router.push({ name: 'viewTemplateDetails', params: {selectedId : selectedId } });

      } catch (error) {
        console.error("Error saving category:", error);
        // Handle error here
      }
    },
    validateForm() {
      // Implement form validation if needed
      return true; // For now, assuming the form is always valid
    },
    goBack() {
      
      this.$router.push({ name: 'viewTemplateDetails', params: {selectedId : selectedId } });
    },
    handleFileUpload(event) {
      this.image = event.target.files[0];
    },
  },
  created() {
    console.error("Larry");
    console.error(this.$route.params.selectedId);
    // Initialize selectedId when the component is created
    this.selectedId = this.$route.params.selectedId;

    console.error("selectedId", selectedId);


    // Fetch templates when the component is created
  }
};
</script>

<style scoped>
.back-btn {
  background-color: grey;
  color: white;
  border-radius: 20px;
}

.confirm-btn {
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.cancel-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.save-btn {
  background: rgb(23, 74, 133);
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
  border-radius: 20px;
}

.popup-heading-text {
  background-color: white;
  width: 100%;
  height: 300px;
  font-size: 18px;
  font-weight: bold;
  padding: 20%;
}

.card1 {
  box-shadow: 0px 0px 0px 1px black;
  background-color: #005157;
  /* height:50px; */
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  color: white;
  text-align: center;
  padding: 15px;
}

.card {
  box-shadow: 0px 0px 0px 1px #005157;
  width: 100%;
  border-radius: 0px 0px 12px 12px;
  text-align: center;
}

.header {
  text-align: left;
}

.v-text-field {
  min-height: "20px";
  height: 70px;
}

.v-btn {
  margin-left: 2%;
}

.white--text {
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
}
</style>
